export const SOURCE_SELECTION_CONTAINER_ID = 'source-selection-container-id';
